module.exports = __webpack_public_path__ + "static/media/NBA2K19.338d41e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/NBA2K19/top/NBA2K19.mp4
// module id = R7Uc
// module chunks = 0